export class StartTimeDateFilters {
    'startDate';
    'endDate';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "string",
            "format": ""
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartTimeDateFilters.attributeTypeMap;
    }
    constructor() {
    }
}
